// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"651":"5b56383b","847":"6f2e21ce"}[chunkId] + ".chunk.css";
};